
import { handler, HandlerBody, gridQuery, parseMsDate, extHandlerRaw } from ".";
import { Config, InstantMessagerConversationState, InstantMessagerParticipantEndpointScheme, Identifier, InstantMessageConversation, EventSubscription, InstantMessagerJoinState, ConversationFlags } from "../model";
import { FSep, MessageType, MSep, RSep } from "../uc-messaging";

export type ParticipantEndPoint = {
  endpointScheme: InstantMessagerParticipantEndpointScheme
  endpointServer: string
  endpointDeviceId: string
}

function directoryHandlerRaw(config: Config, id: MessageType, message: string) {
  return handler('/Teams/Handlers/DEH.ashx', { client: id + FSep + config.sessionId + "=" + config.socketId + FSep + config.extension + FSep + message }, false, 'GET')
}

function instantMessagerHandlerRaw(body: HandlerBody, ucStatus = true) {
  return handler('/Handlers/InstantMessagingHandler.ashx', body, ucStatus)
}

export async function getInstantMessager(conversationId: string, socketId: string ) {
  await instantMessagerHandlerRaw({ command: 'get', data: conversationId, socketId }, true)
}

export async function sendMessage(conversationId: string, message: string, urgent: boolean, socketId: string) {
  return await instantMessagerHandlerRaw({ command: MessageType.REQUEST_IM_DEVICE_SEND_CONVERSATION_MESSAGE.toString(), data: conversationId + FSep + message + FSep + (urgent ? '1' : '0') + FSep + RSep + MSep, socketId }, true)
}
export async function sendParticipantActivity(conversationId: string, typing: boolean, socketId: string) {
  await instantMessagerHandlerRaw({ command: MessageType.REQUEST_IM_DEVICE_SET_CONVERSATIONSTATE.toString(), data: conversationId + FSep + (typing ? InstantMessagerConversationState.startedtyping : InstantMessagerConversationState.stoppedtyping) + FSep + RSep + MSep, socketId }, true)
}

export async function sendParticipantInvite(config: Config, conversationId: string, participantId: string) {
  await directoryHandlerRaw(config, MessageType.REQUEST_IM_SENDINVITE, conversationId + FSep + participantId + FSep + RSep + MSep)
}

export async function hideConversation(conversationId: string, socketId: string) {
  return await extHandlerRaw({ command: 'im-hide', data: JSON.stringify([conversationId]), socketId: socketId }, true)
}

export async function createConversation(config: Config, paraticpants?: ParticipantEndPoint[], key?: string) {
  const x = Math.floor(0 + Math.random() * (10000000 + 1 - 0)).toString()
  let values = ''
  paraticpants && paraticpants.forEach(element => {
    values += element.endpointScheme + FSep + element.endpointDeviceId + FSep + element.endpointServer + FSep + RSep;
  });
  await directoryHandlerRaw(config, MessageType.REQUEST_IM_CREATECONVERSATION, key ? key : x + FSep + RSep + values + MSep)
}

export async function getOneOnOneConversation(config: Config, endPoint: ParticipantEndPoint) {
  const key = randomKey()
  await directoryHandlerRaw(config, MessageType.REQUEST_IM_DEVICEGETONETOONECONVERSATION, endPoint.endpointScheme + FSep + endPoint.endpointDeviceId + FSep + endPoint.endpointServer + FSep + key + FSep + RSep + MSep)
}

export async function addParticipant(config: Config, conversationId: string, endPoint: ParticipantEndPoint) {
  await directoryHandlerRaw(config, MessageType.REQUEST_IM_ADDPARTICIPANT, conversationId + FSep + 1 + FSep + RSep + endPoint.endpointScheme + FSep + endPoint.endpointDeviceId + FSep + endPoint.endpointServer + FSep + RSep + MSep)
}

export async function removeParticipant(config: Config, conversationId: string, participantId: string, currentUserParticipantId: string) {
  if (participantId === currentUserParticipantId) {
    await directoryHandlerRaw(config, MessageType.REQUEST_IM_REMOVESELF, conversationId + FSep + RSep + MSep)
  }
  else {
    await directoryHandlerRaw(config, MessageType.REQUEST_IM_REMOVEPARTICIPANT, conversationId + FSep + participantId + FSep + RSep + MSep)
  }
}

export async function setConversationTitle(config: Config, conversationId: string, title: string) {
  await directoryHandlerRaw(config, MessageType.REQUEST_IM_SETCONVERSATIONTITLE, conversationId + FSep + title + FSep + RSep + MSep)
}

export async function joinConversation(config: Config, conversationId: string, userData? : string, displayName? : string) {
  const key = userData ? userData : randomKey()
  await directoryHandlerRaw(config, MessageType.REQUEST_IM_JOINCONVERSATION, conversationId + FSep + key + FSep + displayName + FSep + RSep + MSep)
}

function randomKey() {
  return 'KEY' + Math.floor(0 + Math.random() * (10000000 + 1 - 0)).toString()
}

export async function setConversationAsRead(config: Config, conversationId: string) {
  await directoryHandlerRaw(config, MessageType.BROADCAST_IM_MARKCONVERSATIONASREAD, conversationId + FSep + FSep + RSep + MSep)
}

export async function leaveConversation(config: Config, conversationId: string, markAsUnread: boolean = false) {
  await directoryHandlerRaw(config, MessageType.REQUEST_IM_REMOVECONVERSATION, conversationId + FSep + (markAsUnread ? '1' : '0') + FSep + RSep + MSep)
}

export async function getInstantMessagers(extension: Identifier, socketId: string) {
  return (await gridQuery('instantmessage', '0', extension.server, EventSubscription.Add, extension.id, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, socketId)).rows.map<InstantMessageConversation>(row => ({
    conversationId: row.conversationId,
    conversationTitle: row.conversationTitle,
    createdUtc: parseMsDate(row.createdUtc) || 0,
    lastUpdatedUtc: parseMsDate(row.lastUpdatedUtc) || 0,
    conversationFlags: ConversationFlags.None,
    deviceEndpoint: row.deviceEndpoint,
    unreadMessagesTotal: row.unreadMessagesTotal,
    unreadUrgentMessagesTotal: row.unreadUrgentMessagesTotal,
    lastUnreadMessage: row.lastUnreadMessage,
    removedFromConversationTitle: row.removedFromConversationTitle,
    removedFromConversationTimestampUtc: row.removedFromConversationTimestampUtc,
    recipients: row.recipients,
    participants: [],
    createdStoreDateUtc: parseMsDate(row.lastUpdatedUtc) || 0,
    joined: InstantMessagerJoinState.none,
  }))
}


